<nz-spin [nzSpinning]="loading">
  <div *ngIf="loading" class="brand-page-loading"></div>
  <ng-content></ng-content>
</nz-spin>
